<template>
  <div>
    <template v-if="product && productPrice">
      <div v-if="hasBreadcrumbs || hasReviews" class="mb-4 hidden items-start gap-4 between lg:flex">
        <pdp-section-breadcrumbs v-if="hasBreadcrumbs" class="min-w-0 grow wrap" />
        <div v-if="hasReviews" class="ml-a shrink-0 py-1">
          <slot name="reviews-summary" />
        </div>
      </div>

      <div class="flex" :class="isOmnibus || isSaleOnSale ? 'f-col items-start gap-1' : 'items-baseline gap-x-6'">
        <h1 class="min-w-0 grow subtitle-2 fw-normal overflow-wrap-anywhere" data-test-id="product-name">
          {{ product.name }}
        </h1>

        <div
          class="flex shrink-0 items-center gap-x-1"
          :class="isOmnibus || isSaleOnSale ? 'text-left' : 'text-right'"
        >
          <product-pricing
            class="subtitle-2 o:fw-normal"
            :currency="product.currency"
            :is-digital-product
            :price="productPrice"
            :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
            :show-omnibus-badge="$feature.showOmnibusBadgeOnQuickshopAndPDP"
            show-omnibus-details
            show-sale-price-tooltip
          />
        </div>
      </div>

      <p
        v-if="product.shortDescription && $feature.showShortDescriptionOnPDP"
        class="mt-1 body-4"
        data-test-id="product-subtitle"
      >
        {{ product.shortDescription }}
      </p>

      <div ref="promoContainerRef" class="body-4 space-y-2" :class="{ 'mt-2': promoContainerHeight }">
        <p v-if="product.promoExclusionsMessage">
          {{ product.promoExclusionsMessage }}
        </p>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
const {
  isDigitalProduct,
  product,
  productPrice,
  reviewsSummaryData,
} = usePdp()

const { $feature } = useNuxtApp()
const promoContainerRef = ref()
const { height: promoContainerHeight } = useElementBounding(promoContainerRef)

const hasBreadcrumbs = computed(() => Boolean(product.value?.breadcrumbs?.length))
const hasReviews = computed(() => Boolean(reviewsSummaryData.value?.rollup?.reviewCount))

const isOmnibus = computed(() => {
  const price = productPrice.value
  if (!$feature.showOmnibusPricing || !price || price.historicBestPrice === undefined)
    return false

  return price.lowCurrent < price.lowOriginal && price.lowCurrent < price.historicBestPrice
})
const isSaleOnSale = computed(() => {
  const price = productPrice.value
  if (!price?.previousBestSalesPrice)
    return false

  return price.highCurrent < price.previousBestSalesPrice
    && price.previousBestSalesPrice < price.lowOriginal
})
</script>
